import { mainPostAListingRoute } from 'modules/main/main.routes';

import { PostOnIdealistDropdownData } from './PostOnIdealistDropdownData';

export const postOnIdealistDropdownDataEs: PostOnIdealistDropdownData = {
  triggerText: 'Publica',
  triggerHref: mainPostAListingRoute.with({}),
  search: {
    title: 'Publica',
    items: [
      {
        type: 'post-a-listing',
        title: 'Publica una Oportunidad',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Suma tu Organización',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Suma tu Colectivo Ciudadano',
        href: '/organizations/create',
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        image: 'illustrations/gear-illustration.svg',
        title: 'Herramientas para Reclutadores',
        description:
          'Herramientas y consejos útiles para contratar y retener el mejor talento para tu causa',
        href: '/es/orgs/encuentra-talento',
      },
      {
        image: 'illustrations/talk-illustration.svg',
        title: 'Centro de Ayuda',
        description:
          'Espacio para resolver todas y cada una de tus preguntas sobre Idealist.org.',
        href: '/es/ayuda',
      },
    ],
  },
};
